<div class="p-6" style="min-width: 300px;">

  <!-- Title -->
  <h2 class="text-center font-bold text-xl mb-5 orange-text">
    {{ isEditMode ? 'Edit Account' : 'Create Account' }}
  </h2>

  <div class="flex flex-col justify-center items-center gap-2">

    <!-- Username -->
    <div *ngIf="!isEditMode || isAdmin" class="flex flex-col" style="width: 320px;">
      <div class="card-input flex items-center text-xs py-2"
            [class.border-red-500]="isInvalid('username')"
            [style.border-color]="isInvalid('username') ? '#e3342f' : ''">
        <span class="text-xs w-130-px font-semibold">Username:</span>
        <input
          [formControl]="form.controls['username']"
          type="text"
          placeholder="Username"
          class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
        >
      </div>
      <span *ngIf="getFieldError('username')"
          class="font-semibold mt-1"
          style="color: #e3342f; font-size: 10px;">
        {{ getFieldError('username') }}
      </span>
    </div>

    <!-- First Name -->
    <div class="flex flex-col" style="width: 320px;">
      <div class="card-input flex items-center text-xs py-2"
            [class.border-red-500]="isInvalid('firstName')"
            [style.border-color]="isInvalid('firstName') ? '#e3342f' : ''">
        <span class="text-xs w-130-px font-semibold">First Name:</span>
        <input
          [formControl]="form.controls['firstName']"
          type="text"
          placeholder="First Name"
          style="text-transform: capitalize;"
          class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
        >
      </div>
      <span *ngIf="getFieldError('firstName')"
            class="font-semibold mt-1"
            style="color: #e3342f; font-size: 10px;">
        {{ getFieldError('firstName') }}
      </span>
    </div>

    <!-- Last Name -->
    <div class="flex flex-col" style="width: 320px;">
      <div class="card-input flex items-center text-xs py-2"
            [class.border-red-500]="isInvalid('lastName')"
            [style.border-color]="isInvalid('lastName') ? '#e3342f' : ''">
        <span class="text-xs w-130-px font-semibold">Last Name:</span>
        <input
          [formControl]="form.controls['lastName']"
          type="text"
          placeholder="Last Name"
          style="text-transform: capitalize;"
          class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
        >
      </div>
      <span *ngIf="getFieldError('lastName')"
            class="font-semibold mt-1"
            style="color: #e3342f; font-size: 10px;">
        {{ getFieldError('lastName') }}
      </span>
    </div>

    <!-- Email -->
    <div class="flex flex-col" style="width: 320px;">
      <div class="card-input flex items-center text-xs py-2"
            [class.border-red-500]="isInvalid('email')"
            [style.border-color]="isInvalid('email') ? '#e3342f' : ''">
          <span class="text-xs w-130-px font-semibold">Email:</span>
        <input
          [formControl]="form.controls['email']"
          type="email"
          placeholder="Email"
          class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
        >
      </div>
      <span *ngIf="getFieldError('email')"
            class="font-semibold mt-1"
            style="color: #e3342f; font-size: 10px;">
        {{ getFieldError('email') }}
      </span>
    </div>

    <!-- Account Type -->
    <div *ngIf="!isEditMode || isAdmin" class="flex flex-col" style="width: 320px;">
      <app-custom-dropdown-v2
        style="width: 320px;"
        label="Account Type:"
        [options]="accountTypeOptions"
        [selectedText]="selectedAccountType?.label || ''"
        placeholder="== Select an option =="
        [hasError]="isInvalid('accountType')"
        [showError]="true"
        [errorMessage]="getFieldError('accountType')"
        [onTouched]="touchAccountType.bind(this)"
        (selectionChange)="setAccountType($event)"
        >
      </app-custom-dropdown-v2>
    </div>

    <!-- API Error Message -->
    <div *ngIf="apiError"
        class="flex items-center justify-center mt-4 px-4">
      <span class="font-semibold text-center text-md"
            style="color: #e3342f;">
        {{ apiError }}
      </span>
    </div>


  </div>

  <!-- Action buttons -->
  <div class="flex items-center justify-center gap-3 mt-6">
    <span
      [style.cursor]="!isFormValid ? 'not-allowed' : 'pointer'"
      [matTooltip]="!hasChanges ? 'No changes made' : (!isFormValid ? 'Please fill in all required fields' : '')"
      [matTooltipDisabled]="isFormValid"
      matTooltipPosition="left"
      matTooltipClass="custom-orange-tooltip"
    >
      <button
        appDisableWithoutPermission="admin.manage"
        matTooltip
        matTooltipClass="custom-orange-tooltip"
        (click)="store()"
        [disabled]="!isFormValid"
        class="uppercase custom-btn power-btn3 disabled-opacity active font-semibold text-sm"
        style="padding: 8px 12px;">
        {{ isEditMode ? 'Submit' : 'Save' }}
      </button>
    </span>
    <button
      (click)="close()"
      class="uppercase custom-btn power-btn3 font-semibold text-sm"
      style="padding: 8px 12px;">
      Cancel
    </button>
  </div>

</div>

<ngx-spinner type="border" size="medium">
  <app-megapay-loader></app-megapay-loader>
</ngx-spinner>